const mobileStickyBar = document.querySelector('.mobile-sticky-bar');
const sectionsToHide = document.querySelectorAll('.hide-sticky-bar-section');

function updateMobileStickyBarHeight() {
  let barHeight = `${mobileStickyBar.offsetHeight}px`; // Get the height of the sticky bar
	if (window.innerWidth > 749) {
		barHeight = '0px'; 
	}

  document.documentElement.style.setProperty('--sticky-bar-height', barHeight);
}

function showmobileStickyBar() {
  const endScreenOnScroll = document.body.offsetHeight - window.innerHeight * 1.5;

  if (document.documentElement.scrollTop > (window.innerHeight / 2) && document.documentElement.scrollTop < endScreenOnScroll && !mobileStickyBar.classList.contains('js-hidden')) {
    mobileStickyBar.classList.add('active');
  } else {
    mobileStickyBar.classList.remove('active');
  }
}

function hideBarWhenOverSections() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          mobileStickyBar.classList.add('js-hidden'); // Add a class to hide the bar
        } else {
          mobileStickyBar.classList.remove('js-hidden'); // Remove the class when not overlapping
        }
      });
    },
    {
      root: null, // Use the viewport as the container
      threshold: 0, // Trigger when 10% of the section is visible
    }
  );

  sectionsToHide.forEach((section) => observer.observe(section));
}

let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) {
    requestAnimationFrame(() => {
      showmobileStickyBar();
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });

window.addEventListener('load', () => {
  updateMobileStickyBarHeight();
	hideBarWhenOverSections();
});

window.addEventListener('resize', () => {
  updateMobileStickyBarHeight();
});